import { render, staticRenderFns } from "./staff.vue?vue&type=template&id=922f05a6&scoped=true"
import script from "./staff.vue?vue&type=script&lang=js"
export * from "./staff.vue?vue&type=script&lang=js"
import style0 from "./staff.vue?vue&type=style&index=0&id=922f05a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "922f05a6",
  null
  
)

export default component.exports